/**
 * Route for `igaming-player-segmentation`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingPlayerSegmentationPage } from "../features/igaming-player-segmentation/IgamingPlayerSegmentationPage";

export const igamingPlayerSegmentationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-player-segmentation",
	component: IgamingPlayerSegmentationPage,
});

export default igamingPlayerSegmentationRoute;
